<template>
<!--对话框 获取所有按钮列表-->
  <el-dialog :visible="isShow" :width="width" :close-on-click-modal="false" :modal-append-to-body="false" :append-to-body="true" :show-close="false">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 功能按钮选择</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-button type="success" size="mini" icon="el-icon-finished" @click="enterHandler">确定选择</el-button>
    <div class="dialog-main-container">
      <el-table :data="ds" size="mini" height="410px" style="width: 100%;" stripe border header-row-class-name="list-header-row" row-class-name="list-row" @selection-change="selectHandler">
        <el-table-column type="selection" width="47" align="center"></el-table-column>
        <el-table-column label="按钮名称" prop="button_name" width="150" header-align="center"></el-table-column>
        <el-table-column label="备注" prop="remark" header-align="center"></el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'EzzDialogAllBtns',
  props: {
    // 定义一个属性，将父级对象传入当前组件中
    parent: {
      type: Object,
      default: () => null
    },
    width: {
      type: String,
      default: '50%'
    }
  },
  data: function () {
    return {
      isShow: false,
      ds: [],
      // 选中的按钮集合
      selectedButtons: [],
      parentBtnListName: ''
    }
  },
  mounted: function () {
  },
  methods: {
    loadData: function () {
      let _this = this
      _this.ds = []
      _this.get(_this.$apis.getAllButtons, { }, function (res) {
        let _json = res.data
        _this.ds = _json.buttons
      })
    },
    open: function (_parentBtnListName) {
      this.parentBtnListName = _parentBtnListName
      this.loadData()
      this.isShow = true
    },
    close: function () {
      this.isShow = false
    },
    // 多选事件
    selectHandler: function (selection) {
      this.selectedButtons = selection
    },
    // 确定选择事件
    enterHandler: function () {
      let _this = this
      let _selectedCount = this.selectedButtons.length
      for (let i = 0; i < _selectedCount; ++i) {
        // 此处必须进行深拷贝，否则添加的明细，将都指向了一个对象
        let _newDetail = JSON.parse(JSON.stringify(_this.parent.emptyButtonData))
        _newDetail.button_name = _this.selectedButtons[i].button_name
        _newDetail.button_type = _this.selectedButtons[i].button_type
        _newDetail.button_icon = _this.selectedButtons[i].button_icon
        _newDetail.fn = _this.selectedButtons[i].fn
        _newDetail.sort = (i + 1).toString()
        let _category = _this.parentBtnListName === 'list_page_buttons' ? 'L' : (_this.parentBtnListName === 'form_page_buttons' ? 'F' : 'V')
        _newDetail.category = _category
        // 通过数组的属性，给选中的菜单的关联项（按钮集合）增加数据
        _this.parent.selectedMenu[_this.parentBtnListName].push(_newDetail)
      }
      _this.close()
    }
  }
}
</script>
